<template>
 <v-card>
  <v-progress-linear :indeterminate="true" v-show='loading' :height='3' class='flat ma-0 pa-0' ></v-progress-linear>
  <v-toolbar dense flat>
    <v-toolbar-title>Choose a background <span class='hidden-sm-and-down'> for your website</span></v-toolbar-title>
    <v-spacer></v-spacer>
    <v-text-field
      label='Search background images'
      @click:append='search'
      @keyup.enter='search'
      v-model='searchString'
      append-icon="search" class='mt-3' ></v-text-field>
  </v-toolbar>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex xs4 md3 lg2 v-for="img in images" :key="img.id" class='text-xs-center' >
        <div v-if='activeImg === img.id' class='mt-3' >
          <v-progress-circular indeterminate :size="50" color="amber"></v-progress-circular>
          <div>Setting background</div>
        </div>
        <img v-else @click="save(img)" class="image" :src="img.urls.thumb" >
      </v-flex>
    </v-layout>
  </v-container>
  <v-snackbar :timeout="10000" v-model="snackbar" top >
    Background image updated
    <v-btn flat color="pink" @click.native="snackbar = false">Close</v-btn>
  </v-snackbar>
</v-card>
</template>

<script>
import axios from 'axios'
export default {
  name: 'UnsplashSearch',
  data () {
    return {
      snackbar: false,
      activeImg: false,
      loading: false,
      resource: 'practitioner.me.profile',
      reqId: 'practitioner-settings-update',
      searchString: 'wellness',
      searchResponse: {}
    }
  },
  mounted () {
    this.search()
  },
  computed: {
    images () {
      return this.getObjectPath(this.searchResponse, 'data.results', [])
    },
    perPage () {
      return 24
    },
    saveRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    saveRequestStatus () {
      return this.saveRequest.status
    },
    me () {
      return this.$store.getters.me
    }
  },
  watch: {
    saveRequestStatus () {
      if (this.saveRequestStatus === 200) {
        this.snackbar = true
        this.saving = false
        this.activeImg = 0
      }
    }
  },
  methods: {
    search () {
      let payload = {
        headers: {
          Authorization: 'Client-ID e844ef6b655e466ae6355a7ad45e990ca3f96928ad4fa9dc1e6a3939592a3039'
        }
      }
      let vm = this
      vm.loading = true
      let url = `https://api.unsplash.com/search/photos?query=${this.searchString}&orientation=landscape&per_page=${this.perPage}`
      axios.get(url, payload)
        .then((data) => {
          vm.searchResponse = data
          vm.loading = false
        })
    },
    save (img) {
      this.activeImg = img.id
      this.saving = true
      let url = this.getObjectPath(img, 'urls.regular', null)
      if (url) {
        let payload = {
          background_picture: url.replace('https:', '')
        }
        this.$appointmentguru
          .resource(this.resource)
          .id(this.reqId)
          .save(this.me.id, payload)
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// UnsplashSearch.vue?14e43357